import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/observable';

import { User } from '../models/user';
import { AuthService } from './auth.service';

import { environment } from '../../environments/environment';

@Injectable()
export class UserService {

	constructor(private http: Http,
		private authService: AuthService,
		private afDatabase: AngularFireDatabase) { }

	public getUsers(): Observable<User[]> {
		return this.afDatabase.list('/users');
	}

	public getUser(key: string): Observable<User> {
		return this.afDatabase.object(`/users/${key}`);
	}

	public async addUser(user: User) {
		const token = await this.authService.getToken();

		const headers: Headers = new Headers();
		headers.append('Authorization', `Bearer ${token}`);
		headers.append('Content-Type', 'application/json');

		this.http.request(`${environment.functions.baseUrl}/api/users`, {
			headers: headers,
			body: user,
			method: 'POST'
		})
		.subscribe(
		(data) => console.log(data)
		);
	}

	public async updateUser(key: string, user: User) {
		const token = await this.authService.getToken();

		const headers: Headers = new Headers();
		headers.append('Authorization', `Bearer ${token}`);
		headers.append('Content-Type', 'application/json');

		this.http.request(`${environment.functions.baseUrl}/api/users/${key}`, {
			headers: headers,
			body: user,
			method: 'PUT'
		})
		.subscribe(
		(data) => console.log(data)
		);
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/user.service.ts